export class DeleteTimeEntryAction {
  static readonly type = '[Project] Delete Time Entry';

  constructor(public timeEntryId: string) {}
}
